<template>
  <Container full-width>
    <NuxtPage />
  </Container>
</template>
<script setup>
definePageMeta({
  layout: 'admin',
  middleware: ['authenticated']
})
useHead({
  meta: [
    {
      name: 'robots',
      content: 'noindex'
    }
  ]
})
</script>
<style>
h1 {
  view-transition-name: title;
}

root::view-transition(title) {
  transform: translateX(-100%);
}
</style>
